'use strict';


export default function(incidents) {
	'ngInject';

	var vm = this;

	vm.archived = false;

	vm.process = function(incident) {
		if (Array.isArray(incident)) {
			incident.forEach(vm.process);
		} else {
			incidents.process(incident);
			incident.formNames = incident.forms.map(function(form) {
				return form.name;
			});
			incident.hasForm = function(name) {
				return incident.formNames.indexOf(name) >= 0;
			}
		}
	}

	var versions = {};
	vm.register = function(version, query) {
		versions[version] = query;
	}
}
